// AI Generated Test
import { Component, Input } from '@angular/core';

@Component({
    selector: 'cookie-acceptance-rate',
    standalone: false,
    template: `
        <div class="cookie-statistics-distribution-bar d-flex flex-column">
            <div class="header d-flex justify-content-between">
                <div class="text-bold">{{ name }}</div>
                <div class="p-dark">
                    {{ percentage | monNumber:'0.[00]'}} %
                </div>
            </div>
            <div class="progress-xxs progress-square mb-2">
                <ngb-progressbar class="mr-2" [value]="percentage" [type]="setNameForBarClass(name)"></ngb-progressbar>
            </div>
        </div>
    `,
})
export class CookieAcceptanceRateComponent {
    @Input() percentage: any;
    @Input() name: any;

    setNameForBarClass (name: any): any {
        return name.toLowerCase();
    }
}
